export function supportHomePath(method) {
  if (method) return `/support?method=${encodeURIComponent(method)}`;
  return "/support";
}

export function supportPatientPath(patientId, { doctorId, date, mrn } = {}) {
  const params = new URLSearchParams();
  if (doctorId) params.set("doctorId", doctorId);
  if (date) params.set("date", date);
  if (mrn) params.set("mrn", mrn);

  const query = params.toString();
  return `/support/patient/${encodeURIComponent(patientId)}${
    query ? `?${query}` : ""
  }`;
}

export function supportMrnPath(mrn) {
  return `/support/mrn/${encodeURIComponent(mrn)}`;
}

export function supportTicketPath(ticketId) {
  return `/support/ticket/${encodeURIComponent(ticketId)}`;
}

/**
 * Absolute link for a shared agent session. Shared links reuse the existing
 * ticket/patient pages with a `share` search param; the page hydrates the
 * conversation from the snapshot.
 */
export function sharedSessionUrl({ shareId, ticketId, patientId }) {
  const path = ticketId
    ? supportTicketPath(ticketId)
    : supportPatientPath(patientId);
  return `${window.location.origin}${path}?share=${encodeURIComponent(shareId)}`;
}

export function supportDoctorPath(doctorId, date) {
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  const query = params.toString();
  return `/support/doctor/${encodeURIComponent(doctorId)}${
    query ? `?${query}` : ""
  }`;
}

export function getSupportBackPath(searchParams) {
  const doctorId = searchParams.get("doctorId");
  const date = searchParams.get("date");
  const mrn = searchParams.get("mrn");

  if (doctorId) {
    return supportDoctorPath(doctorId, date || undefined);
  }
  if (mrn) {
    return supportMrnPath(mrn);
  }
  return supportHomePath("patient-id");
}

export function getSupportBackLabel(searchParams) {
  if (searchParams.get("doctorId")) {
    return "Back to doctor's patients";
  }
  if (searchParams.get("mrn")) {
    return "Back to MRN results";
  }
  return "Change patient";
}

export function todayIsoDate() {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

/** Best-effort convert a patient appointment date to YYYY-MM-DD for doctor schedule URLs. */
export function appointmentDateToIso(dateStr) {
  if (!dateStr?.trim()) return undefined;
  const trimmed = dateStr.trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;

  const d = new Date(trimmed);
  if (Number.isNaN(d.getTime())) return undefined;

  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

/** Doctor support page path for a patient's assigned doctor (optional appointment date). */
export function supportDoctorPathFromPatient(patient, doctor) {
  const doctorId = doctor?.user_id || patient?.user_id;
  if (!doctorId) return null;

  const date = appointmentDateToIso(patient?.date_of_appt);
  return supportDoctorPath(doctorId, date);
}
